import React from 'react';

import {
  minLength,
  ReferenceArrayInput,
  required,
  SelectArrayInput,
} from 'react-admin';

import { Box } from '@mui/material';

import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const GroupDuration = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Groups" description="Select one or more groups. Only entities that are members of at least one of the selected groups are included. At least one group is required.">
      <ReferenceArrayInput
        source="report.groupIds"
        reference="groups"
        perPage={200}
        filter={{ active: true }}
      >
        <SelectArrayInput label="" helperText={false} validate={[required(), minLength(1)]} />
      </ReferenceArrayInput>
    </FieldBox>
    <FieldBox title="Date range" description="Only group membership events within this date range are included. Default: 2000-01-01 to execution time.">
      <RangeFields
        from={(
          <SmartDateInput
            fullWidth
            validate={[isPastDate, dateRangeValidation]}
            source="report.dateFrom"
            label="Date from"
            helperText={false}
          />
        )}
        to={(
          <SmartDateInput
            fullWidth
            validate={[isPastDate, dateRangeValidation]}
            source="report.dateTo"
            label="Date to"
            helperText={false}
          />
        )}
      />
    </FieldBox>
  </Box>
);

export default GroupDuration;
